import { render } from "./UpgradeOverlay.vue?vue&type=template&id=46ecce7e&scoped=true"
import script from "./UpgradeOverlay.vue?vue&type=script&lang=js"
export * from "./UpgradeOverlay.vue?vue&type=script&lang=js"

import "./UpgradeOverlay.vue?vue&type=style&index=0&id=46ecce7e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ecce7e"]])

export default __exports__